module.exports = __webpack_public_path__ + "img/blog-19.d1b1e498.webp";